/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { positionChangeWidthSm, navbarHeight, footerHeight, hingeProfileBackgroundColor, hingeProfileImageDimension, hingeProfileItemBorderColor, hingeProfileItemDividerOpacity, hingeProfileItemBoxShadow, hingeProfileItemBorderWidth, hingeProfileItemBorderRadius, swipelyticsTurquoise, profPicDefaultURL } from '../../../../../helpers/variableDefaults'


export const viewHingeNameAndPronounsItem = (datingProfile, width) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          // width: '100%',
          width: hingeProfileImageDimension(width),
          fontWeight: 'bold',
          fontSize: '18px',
        }}
      >
        {datingProfile.bio.vitalInfo.firstName}
      </Typography>

      {'pronouns' in datingProfile.bio.vitalInfo 
        && datingProfile.bio.vitalInfo.pronouns !== 'Prefer not to say' 
        &&
        <Typography
          sx={{
            width: '100%',
            fontStyle: 'italic',
          }}
        >
          {datingProfile.bio.vitalInfo.pronouns}
        </Typography>
      }

    </Box>
  )
}